// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item {
  border: 1px solid var(--ion-item-border-color);
}

ion-modal {
  --width: 290px;
  --height: 400px;
  --border-radius: 8px;
}

ion-item.checkbox {
  border: 0;
  --background: transparent;
  --padding-start: 0;
}
ion-item.checkbox ion-label {
  white-space: inherit;
}
ion-item.checkbox ion-checkbox {
  margin-right: 10px;
  --border-color-checked: transparent;
  --border-radius: 5px;
  --border-width: 2px;
  --border-color: #C6C6C6;
  --checkmark-width: 3px;
  --size: 26px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/admin/projects/modals/create-milestone/create-milestone.page.scss"],"names":[],"mappings":"AAAA;EACI,8CAAA;AACJ;;AAEA;EACI,cAAA;EACA,eAAA;EACA,oBAAA;AACJ;;AAGA;EACI,SAAA;EACA,yBAAA;EACA,kBAAA;AAAJ;AAEI;EACI,oBAAA;AAAR;AAGI;EACI,kBAAA;EACA,mCAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,YAAA;AADR","sourcesContent":["ion-item {\n    border: 1px solid var(--ion-item-border-color);\n}\n\nion-modal {\n    --width: 290px;\n    --height: 400px;\n    --border-radius: 8px;\n}\n\n\nion-item.checkbox {\n    border: 0;\n    --background: transparent;\n    --padding-start: 0;\n\n    ion-label {\n        white-space: inherit;\n    }\n\n    ion-checkbox {\n        margin-right: 10px;\n        --border-color-checked: transparent;\n        --border-radius: 5px;\n        --border-width: 2px;\n        --border-color: #C6C6C6;\n        --checkmark-width: 3px;\n        --size: 26px;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
